import {
    RaikoGridOneColumn,
    RaikoGridTwoColumn,
    RaikoMaterialOutlinedInput,
    RaikoFlexAlignEnd,
    RaikoButtonPrimary,
    RaikoSimpleMultiLineInputOutlined,
    showSuccessMessage, showWarningMessage,
    RaikoSectionContainer,
    showErrorMessage,
} from "@moeindal/base-raiko-panel-components"
import {css} from "@emotion/css";
import React, {useState} from "react";
import RaikoCustomEditor2 from "../../raikoComponents/raikoEditor/RaikoCustomEditor2";
import {NewsService} from "../../serverService/news/NewsService";
import {dataURLtoFile} from "../../util/converBase64ToImage";
import {stringIsEmpty} from "../../util/VariableChecker";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import InternalImageSelector from "../../raikoComponents/raikoEditor/internalImageSelector/InternalImageSelector";
import {FileManagerTypes} from "../../component/fileManager/FileManager";

export default function AddNewNews({handleAddNewNewsToList}) {

    const [title, setTitle] = useState("");
    const [writerName, setWriterName] = useState("");
    const [shortDescription, setShortDescription] = useState("")
    const [description, setDescription] = useState([]);

    //photo
    const [photoId, setPhotoId] = useState(-1);
    const [photoUrl, setPhotoUrl] = useState("");
    //photo

    const service = new NewsService()
    const loading = new LoadingHelper(useLoadingDispatcher())

    function checkFields() {
        let state = false
        let message

        if (stringIsEmpty(title))
            message = "لطفا عنوان خبر را به درستی وارد نمایید."
        else if (stringIsEmpty(writerName))
            message = "لطفا نویسنده خبر را به درستی وارد نمایید."
        else if (photoId === -1)
            message = "لطفا تصویر شاخص را انتخاب نمایید."
        else if (stringIsEmpty(shortDescription))
            message = "لطفا توضیحات کوتاه خبر را به درستی وارد نمایید."
        else if (stringIsEmpty(description))
            message = "لطفا توضیحات خبر را به درستی وارد نمایید."
        else
            state = true

        if (message)
            showWarningMessage(message)

        return state

    }

    function handleAddNewNews() {
        if (checkFields()) {
            loading.show()
            service.addNewNews(
                photoId,
                title,
                writerName,
                description,
                shortDescription,
            ).then(response => {
                handleAddNewNewsToList(response)
                showSuccessMessage("خبر جدید با موفقیت افزوده شد.")
            }).catch(reason => {
                console.log(reason)
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                loading.hide()
            })
        }
    }

    return (
        <RaikoGridOneColumn className={css`padding: 0 1rem 1rem 1rem;`}>
            <RaikoGridTwoColumn>
                <RaikoMaterialOutlinedInput
                    labelText={"عنوان"}
                    value={title}
                    setValue={setTitle}
                />
                <RaikoMaterialOutlinedInput
                    labelText={"نام نویسنده"}
                    value={writerName}
                    setValue={setWriterName}
                />
            </RaikoGridTwoColumn>
            <RaikoSimpleMultiLineInputOutlined
                labelText={"توضیحات کوتاه"}
                value={shortDescription}
                setValue={setShortDescription}
            />
            <InternalImageSelector
                value={photoUrl}
                setValue={setPhotoUrl}
                imageId={photoId}
                setImageId={setPhotoId}
                bucketId={FileManagerTypes.NEWS_THUMBNAILS.id}
                title={"تصویر شاخص"}
            />
            <RaikoSectionContainer title={"توضیحات"}>
                <RaikoCustomEditor2
                    value={description}
                    setValue={setDescription}
                />
            </RaikoSectionContainer>
            <RaikoFlexAlignEnd>
                <RaikoButtonPrimary
                    label={"افزودن"}
                    onClick={handleAddNewNews}
                />
            </RaikoFlexAlignEnd>
        </RaikoGridOneColumn>
    )
}